import React, { useEffect, useState } from 'react';
import getBooks from '../api/get/getBooks';
import { useSystemTheme } from '../utils/useSystemTheme';
import { auth } from '../config';
import { postFeedback } from '../api/post/postFeedback';

import arrow_left from '../assets/icons/lightOutline/Arrow - Left 2.svg';

function BuyBookProblem() {
    const theme = useSystemTheme();
    const user = auth.currentUser;

    const [books, setBooks] = useState([]);
    const [loading, setLoading] = useState(true);

    const [selectedBook, setSelectedBook] = useState(null);
    const [feedbackText, setFeedbackText] = useState('');
    const [sending, setSending] = useState(false);

    useEffect(() => {
        const fetchBooks = async () => {
            try {
                const allBooks = await getBooks('bookAudio');
                const filteredBooks = allBooks.filter((book) => book.isPaid);
                setBooks(filteredBooks);
            } catch (error) {
                console.error('Error fetching books:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchBooks();
    }, []);

    const handleFeedbackSubmit = async (e) => {
        e.preventDefault();
        if (!feedbackText.trim() || !selectedBook || !user) return;
        setSending(true);
        try {
            await postFeedback({
                name: selectedBook.id,
                email: user.uid,
                message: feedbackText.trim(),
                type: 'message',
            });
            alert('Пікіріңіз жіберілді!');
            setFeedbackText('');
            setSelectedBook(null);
        } catch (err) {
            console.error('Пікір жіберу қатесі:', err);
        } finally {
            setSending(false);
        }
    };

    return (
        <div
            className={`min-h-screen flex flex-col ${theme === 'dark' ? 'bg-gray-900 text-white' : 'bg-gray-50 text-gray-800'
                }`}
        >
            {/* Header */}
            <header className="bg-white shadow-md py-4 px-6 sticky top-0 z-10 flex items-center gap-4">
                <button onClick={() => window.history.back()} className="p-2 rounded hover:bg-gray-100">
                    <img src={arrow_left} alt="Back" className="w-6 h-6" />
                </button>
                <h1 className="text-2xl font-bold text-blue-600">Кітап сатып алуда қиындықтар</h1>
            </header>

            {/* Content */}
            <main className="flex-grow px-6 py-8">
                {loading ? (
                    <div className="text-center text-gray-500">Жүктелуде...</div>
                ) : books.length === 0 ? (
                    <p className="text-center text-gray-500">Төленген аудиокітаптар табылмады.</p>
                ) : (
                    <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                        {books.map((book) => (
                            <li
                                key={book.id}
                                onClick={() => setSelectedBook(book)}
                                className="bg-white cursor-pointer p-4 rounded-xl shadow hover:shadow-lg transition"
                            >
                                {book.imageUrl && (
                                    <img
                                        src={book.imageUrl}
                                        alt={book.title}
                                        className="w-full h-48 object-cover rounded-md mb-3"
                                    />
                                )}
                                <h3 className="text-black text-lg font-semibold">{book.title}</h3>
                                <p className="text-sm text-gray-600 mt-1">{book.genre}</p>
                            </li>
                        ))}
                    </ul>
                )}
            </main>

            {/* Modal */}
            {selectedBook && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 px-4">
                    <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-lg relative text-gray-800">
                        <button
                            onClick={() => setSelectedBook(null)}
                            className="absolute top-2 right-3 text-gray-500 hover:text-red-500 text-lg"
                        >
                            &times;
                        </button>
                        <h2 className="text-xl font-semibold mb-4">{selectedBook.title}</h2>
                        {!user ? (
                            <p className="text-red-600">Кіру қажет — пікір қалдыру үшін авторизациядан өтіңіз.</p>
                        ) : (
                            <form onSubmit={handleFeedbackSubmit}>
                                <textarea
                                    value={feedbackText}
                                    onChange={(e) => setFeedbackText(e.target.value)}
                                    rows={4}
                                    className="w-full border border-gray-300 rounded-md p-2 text-gray-800 placeholder-gray-400"
                                    placeholder="Пікіріңізді жазыңыз..."
                                    required
                                />
                                <button
                                    type="submit"
                                    disabled={sending}
                                    className="mt-3 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                                >
                                    {sending ? 'Жіберілуде...' : 'Пікірді жіберу'}
                                </button>
                            </form>
                        )}
                    </div>
                </div>
            )}

            {/* Footer */}
            <footer className="bg-white text-center text-sm text-gray-500 py-4 border-t">
                &copy; {new Date().getFullYear()} Esti кітапханасы. Барлық құқықтар қорғалған.
            </footer>
        </div>
    );
}

export default BuyBookProblem;